import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/admin.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  user: any;
  oldPassword: string = "";
  newPassword: string = "";
  loading: boolean = false;
  changePwdForm: FormGroup;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private adminService: AdminService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.changePwdForm = this.fb.group({
      userID: ["", [Validators.required]],
      Password: ["", Validators.required],
      deviceID: [""],
      deviceToken: [""],
      devicetype: ["web"],
    })
    let bguser = localStorage.getItem("bguser");
    if (bguser) {
      this.user = JSON.parse(bguser);
      this.oldPassword = this.user.Password;
    } else {
      this.router.navigateByUrl('/login')
    }
  }
  submitDetails(){
    
  }
  changePassword() {
    if (this.oldPassword != '' && this.newPassword != '') {
      let payload = {
        userID: this.user.userID,
        NewPassword: this.newPassword,
        OldPassword: this.oldPassword
      }
      this.loading = true;
      this.adminService.changePassword(payload).subscribe((posRes: any) => {
        // console.log(posRes);
        this.loading = false;
        if (posRes.response == 3) {
          this.user.Password = this.newPassword;
          this.oldPassword = this.newPassword;
          this.newPassword = "";
          localStorage.setItem("bguser", JSON.stringify(this.user));
          this.openSnackBar(posRes.message, "");
        } else {
          this.openSnackBar(posRes.message, "")
        }
      }, (err: HttpErrorResponse) => {
        console.log(err);
        this.loading = false;
        this.openSnackBar(err.message, "")
        if (err.error instanceof Error) {
          console.warn("Client Error", err.error)
        } else {
          console.warn("Server Error", err.error)
        }
      })
    } else {
      this.openSnackBar("Enter new password", "");
    }
  }
  //message alerts showing
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }
}
